import { ramblings } from "@/mocks/blog";

const tagColors: Record<string, string> = {
  日常: "bg-secondary-100 text-secondary-700",
  感悟: "bg-primary-100 text-primary-700",
  碎碎念: "bg-accent-100 text-accent-700",
  成长: "bg-secondary-100 text-secondary-700",
  职场: "bg-primary-100 text-primary-700",
  生活: "bg-accent-100 text-accent-700",
};

export default function RamblingsSection() {
  return (
    <section id="rambling" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-primary-50 blur-3xl"></div>
      <div className="mx-auto w-full max-w-5xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">RANDOM THOUGHTS</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            碎碎念 · <span className="text-primary-600">没营养但很真实</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里没有长篇大论，只有想到哪写到哪的心里话。不装深刻，就是我的日常。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {ramblings.map((r, i) => (
            <article
              key={i}
              className={`relative rounded-lg border p-5 ${
                i % 2 === 0
                  ? "border-primary-200/70 bg-primary-50/40"
                  : "border-background-200 bg-background-100"
              }`}
            >
              <i
                className="ri-double-quotes-l absolute right-4 top-3 text-3xl opacity-20 text-primary-300"
                aria-hidden="true"
              ></i>
              <span
                className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${tagColors[r.tag] || tagColors["日常"]}`}
              >
                {r.tag}
              </span>
              <p className="mt-3 pr-4 text-[15px] leading-relaxed text-foreground-800">{r.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}